/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['select-groups-modal{display:block}select-groups-modal .groups{text-transform:capitalize}select-groups-modal .groups>.group{margin-bottom:7px}select-groups-modal .groups>.group.disabled{opacity:.5;cursor:not-allowed}select-groups-modal .groups>.group.disabled>input,select-groups-modal .groups>.group.disabled>label{pointer-events:none}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC91c2VyL3NlbGVjdC1ncm91cHMtbW9kYWwvc2VsZWN0LWdyb3Vwcy1tb2RhbC5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC91c2VyL3NlbGVjdC1ncm91cHMtbW9kYWwvc2VsZWN0LWdyb3Vwcy1tb2RhbC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/user/select-groups-modal/select-groups-modal.component.scss.ngstyle.ts